<template>
  <div class="user-help-element">
    <div class="child" v-for="(item) in listData"  :key="item.document_draft_id || item.id" >
      <div class="item" :class="{'level_1': item.level === 1,'not-children':item.number_of_children_documents === 0, 'active': active === (item.document_draft_id || item.id)}" @click="selectElement(item)">
        <!-- <div class="icon_2 tableIconHover">
          <i class="icon iconfont iconicon_drop_down_arrow" :class="{'rota90': item.open}" v-if="item.children && item.children.length > 0" @click.stop="item.open = !item.open"></i>
        </div> -->
        <toolTip class="title" :title="item.title" style="width: 100%;">
          <i v-if="item.icon" class="icon iconfont" :class="{[item.icon]: true}" :style="{'color': item.color}"></i>
          <span>{{item.title}}</span>
        </toolTip>
      </div>
      <el-collapse-transition >
        <List :pid="item.document_draft_id || item.id" :listData="item.children" :isReviews="isReviews" :select="select"></List>
      </el-collapse-transition>
    </div>
  </div>
</template>
<script>
import bus from '@/bus'
export default {
  name: 'List',
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    isReviews: {
      type: Boolean,
      default: false
    },
    select: {
      type: Number,
      default: -1
    }
  },
  computed: {
    active() {
      return Number(this.$route.query.id || this.select)
    }
  },
  data() {
    return {
    }
  },
  methods: {
    selectElement(item) {
      if(item.level === 1) return
      if(this.isReviews) {
        console.log(666)
        bus.$emit('editReviewClick', item)
        return
      }
      const newUrl = this.$route.path + `?id=${item.document_draft_id || item.id}`
      window.history.replaceState('', '', `${window.location.pathname}#${newUrl}`)
      this.$router.replace({ query: {
        id: item.document_draft_id || item.id
      } })
    }
  }
}
</script>
<style lang="scss">
.user-help-element {
  .item {
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    &:hover {
      background-color: rgba(32, 32, 32, 0.04);
    }
    &:active {
      background-color: rgba(32, 32, 32, 0.08);
    }
    .title {
      i {
        margin-right: 8px;
        font-size: 14px;
      }
    }
    &.active {
      background-color: rgba(32, 32, 32, 0.08);
    }
  }
  .level_1 {
    margin-top: 16px;
    .title {
      color: rgba(32, 32, 32, 0.6);
    }
    border-top: 1px solid rgba(32,32,32,0.08);
    cursor: auto;
    &:hover {
      background-color: initial;
    }
    &:active {
      background-color: initial;
    }
    &.not-children {
      display: none;
    }
  }
  .child:first-child .level_1 {
    border: 0 none;
  }
}
</style>
